import Swiper from './swiper-bundle.esm.browser.min.js';

const v2Carousel = document.querySelector('[data-v2-carousel]');

if (v2Carousel) {
  new Swiper(v2Carousel, {
    slidesPerView: 1,
    spaceBetween: 10,
    centerInsufficientSlides: true,
    pagination: {
      el: '.jkl-product-info-slider__pagination',
      clickable: true,
    },
    breakpoints: {
      480: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      940: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1340: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  });
}
